// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideRotateCw as RawLucideRotateCw } from "lucide-react";
export const LucideRotateCw = /* @__PURE__ */ createIcon(RawLucideRotateCw, "LucideRotateCw", 2);
